import(/* webpackMode: "eager", webpackExports: ["SiteProvider"] */ "/app/lib/site-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Atkinson_Hyperlegible_Mono\",\"arguments\":[{\"variable\":\"--font-atkinson-hyperlegible\",\"subsets\":[\"latin\"],\"weight\":\"400\",\"fallback\":[\"Courier New\",\"monospace\"]}],\"variableName\":\"atkinsonHyperlegible\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Silkscreen\",\"arguments\":[{\"variable\":\"--font-silkscreen\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"]}],\"variableName\":\"silkscreen\"}");
;
import(/* webpackMode: "eager" */ "/app/styles/var.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/styles/components.css");
